import View from "./view";
import icons from 'url:../../img/icons.svg'; //parcel 2


class PaginationView extends View{
    _parentElement = document.querySelector(`.pagination`);


    addHandlerClick(handler){
        this._parentElement.addEventListener(`click`, function(e){
            const btn = e.target.closest(`.btn--inline`);
            if(!btn) return;

            const goToPage = +btn.dataset.goto;
            console.log(goToPage);

            handler(goToPage);
        })
    }

    _generateMarkup(){
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        console.log(numPages);
        //Page 1, and there are other pages
        if(curPage === 1 && numPages > 1){
            return `
            <span class="pagination__info">Page ${curPage} / ${numPages}</span>
            <button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
            <span>Next</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>
          `;
        }

        //Page 1, no other pages
        if(curPage === 1 && numPages === 1){
            return `<span class="pagination__info">Page ${curPage} / ${numPages}</span>
            `;
        }

        //Last page
        if(curPage === numPages && numPages > 1){
            return `
            <button data-goto="${curPage - 1}"class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
            <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Prev</span>
            </button>
            <span class="pagination__info">Page ${curPage} / ${numPages}</span>
          `;
        }
        //Other page
        if(curPage > 1 || curPage < numPages){
            return `            
            <button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Prev</span>
          </button>
          <span class="pagination__info">Page ${curPage} / ${numPages}</span>
          <button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
          <span>Next</span>
          <svg class="search__icon">
            <use href="${icons}#icon-arrow-right"></use>
          </svg>
          </button>
          `;
        }

    }
};

export default new PaginationView();